module.exports = __webpack_public_path__ + "47b60d4a3d23fd5b72e924395ae45f07.jpg";